import axios from 'axios'
import constants from '@/helpers/constants'
import { GoogleEnhancedEcommerce, GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  state: {
    deliveryInfo: null,
    deliveryInfoOurShops: null,
    isDeliveryFormEmpty: false,
    streets: [],
    zipCodes: [],
    lastDeliveryInfo: null,
    isFormSubmitted: false,
    isFormHidden: false,
    isMapTabActive: false,
    isAnotherRecipient: false,
    deliveryCity: {
      // zipCode: '',
      name: '',
      id: ''
    },
    cities: [],
    isFreeEnterDeliveryData: false
  },
  getters: {
    isAnotherRecipient (state) {
      return state.isAnotherRecipient
    },
    selectedSpot (state, getters, rootState) {
      const { deliveryInfo } = rootState.checkout.formData
      if (deliveryInfo && deliveryInfo.deliverySpot) return deliveryInfo.deliverySpot
      return null
    },
    isCityFormValid (state, getters, rootState, rootGetters) {
      return !!state.deliveryCity?.name
    },
    isDeliveryFormValid (state, getters, rootState, rootGetters) {
      const {
        deliveryInfo,
        deliveryType,
        recipientName,
        recipientLastName,
        recipientPhone
      } = rootState.checkout.formData

      if (
        !deliveryInfo ||
        !deliveryType ||
        (rootState.cart.cart.cartStatus === constants.CART_STATUSES.NOT_AVAILABLE && deliveryType && deliveryType.methodId === 1)
      ) {
        return false
      }

      const { invalidFields } = rootState.contactsForm

      if (
        state.isAnotherRecipient &&
        (!recipientName ||
          !recipientLastName ||
          !recipientPhone ||
          invalidFields.recipientName ||
          invalidFields.recipientLastName)
      ) {
        return false
      }

      const { deliverySpot, deliveryTime, house, street, zip, flat } = deliveryInfo
      const { methodId } = deliveryType

      const regLatin = new RegExp(/[a-z]/i)
      const regLatinAndNumber = new RegExp(/^[A-Za-z0-9]*$/)
      const regSpec = new RegExp('[!@#№/$%^&*(),.?:;_=+{}|<>]')

      const validMapDelivery = !!((methodId === 1 || methodId === 3 || methodId === 5 || methodId === 10 || methodId === 11) && deliverySpot)
      const validWarehouseCourierDelivery = !!(methodId === 2 && deliveryTime && house && street)
      const validWarehouseCourierDelivery2 = !!(methodId === 6 && deliveryTime && house && street)
      const validNPCourierDelivery = !!(methodId === 4 && house && street)
      const validEUDelivery = !!((methodId === 9 || methodId === 7) && street && house && regLatinAndNumber.test(house) && zip && regLatin.test(street) && !regSpec.test(flat) && regLatinAndNumber.test(flat))

      return validMapDelivery || validWarehouseCourierDelivery || validNPCourierDelivery || validWarehouseCourierDelivery2 || validEUDelivery
    }
  },
  mutations: {
    SET_CITIES (state, data) {
      state.cities = data
    },
    SET_DELIVERY_INFO (state, data) {
      state.deliveryInfo = data
    },
    SET_DELIVERY_CITY (state, data) {
      state.deliveryCity = data
    },
    SET_DELIVERY_INFO_OUR_SHOPS (state, data) {
      state.deliveryInfoOurShops = data
    },
    SET_DELIVERY_FORM_IS_EMPTY (state, bool) {
      state.isDeliveryFormEmpty = bool
    },
    SET_STREETS (state, streets) {
      state.streets = streets
    },
    SET_ZIP_CODES (state, zipCodes) {
      state.zipCodes = zipCodes
    },
    SET_LAST_DELIVERY_INFO (state, info) {
      state.lastDeliveryInfo = info
    },
    SET_IS_FORM_SUBMITTED (state, bool) {
      state.isFormSubmitted = bool
    },
    SET_IS_FORM_HIDDEN (state, bool) {
      state.isFormHidden = bool
    },
    SET_IS_MAP_TAB_ACTIVE (state, bool) {
      state.isMapTabActive = bool
    },
    SET_IS_ANOTHER_RECIPIENT (state, bool) {
      state.isAnotherRecipient = bool
    },
    SET_IS_FREE_ENTER_DELIVERY_DATA (state, bool) {
      state.isFreeEnterDeliveryData = bool
    }
  },
  actions: {
    SET_IS_FREE_ENTER_DELIVERY_DATA: (ctx, data) => {
      ctx.commit('SET_IS_FREE_ENTER_DELIVERY_DATA', data)
    },
    FETCH_DELIVERY_INFO ({ commit, rootGetters, dispatch, rootState }, params) {
      GoogleTagManagerService.checkoutEvent({
        analyticsData: rootGetters.cartInfoForEcommerce,
        actionField: { 'step': 3, 'option': `${params.methodId}` },
        params: {
          'event': 'gtm-ee-event-checkout-step-3',
          'gtm-ee-event-action': 'Checkout Step 3'
        }
      })

      dispatch('SET_LOADING_COMPONENT', { deliveryTypeInput: true }, { root: true })
      return new Promise(resolve => {
        const deliveryCityId = rootState.deliveryForm.deliveryCity?.id
        if (deliveryCityId) {
          params.cityId = deliveryCityId
        }
        axios
          .get(rootGetters.urlLanguagePrefix + '/shop/checkout/method-details/', { params })
          .then(response => {
            const { deliveryInfo } = rootState.checkout.formData
            if (deliveryInfo && deliveryInfo.deliverySpot) {
              // const deliveryType = { ...rootState?.checkout?.formData?.deliveryType }
              // const haveSelectedMethod = response.data.delivery_data.find(el => el.method_id === deliveryType?.methodId)
              // if (!haveSelectedMethod) {
              //   commit('REDUCE_FORM_DATA', { deliveryType: null })
              //   commit('SET_IS_FORM_HIDDEN', false)
              // }
              const selectedSpot = response.data.delivery_data.find(el => el.uid === deliveryInfo.deliverySpot.uid && el.cart_status === 1)
              if (selectedSpot) {
                commit('REDUCE_FORM_DATA', {
                  deliveryInfo: {
                    deliverySpot: selectedSpot
                  }
                })
                commit('SET_SELECTED_SPOT', selectedSpot)
              } else {
                commit('REDUCE_FORM_DATA', { deliveryType: null })
                commit('SET_IS_FORM_HIDDEN', false)
              }
              // for (let i = 0; i < response.data.delivery_data.length; i++) {
              // if (
              //   deliveryInfo.deliverySpot.uid === response.data.delivery_data[i].ref &&
              //   response.data.delivery_data[i].is_available === '0'
              // ) {
              //   commit('REDUCE_FORM_DATA', { deliveryInfo: null })
              //   commit('SET_IS_FORM_HIDDEN', false)
              // }
              // if (
              //   deliveryInfo.deliverySpot.uid === response.data.delivery_data[i].uid &&
              //   response.data.delivery_data[i].hasOwnProperty('cart_status') &&
              //   response.data.delivery_data[i].cart_status !== deliveryInfo.deliverySpot.cartStatus
              // ) {
              //   commit('REDUCE_FORM_DATA', {
              //     deliveryInfo: {
              //       deliverySpot: {
              //         ...deliveryInfo.deliverySpot,
              //         cartStatus: response.data.delivery_data[i].cart_status
              //       }
              //     }
              //   })
              //   commit('SET_SELECTED_SPOT', {
              //     ...rootState.map.selectedSpot,
              //     cartStatus: response.data.delivery_data[i].cart_status
              //   })
              // }
              // }
            }

            const dmDelivery = rootState.contactsForm.deliveryTypes.find(type => type.methodId === 1)
            if (
              (response.data.slug === 'novaPoshtaWarehouse' || response.data.slug === 'ukrposhta') &&
              dmDelivery &&
              dmDelivery.status
            ) {
              params.methodId = 1

              axios.get(rootGetters.urlLanguagePrefix + '/shop/checkout/method-details/', { params }).then(res => {
                if (res.data) commit('SET_DELIVERY_INFO_OUR_SHOPS', res.data)
              })
            } else {
              commit('SET_DELIVERY_INFO_OUR_SHOPS', null)
            }

            // записываем флаг для блонирования/разблокирования чекбокса
            commit('SET_IS_DISABLED_CALLBACK_STATUS', !response.data.can_checkout_without_call)

            commit('SET_DELIVERY_INFO', response.data)

            resolve()
          })
          .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('server_error')))
          .finally(() => dispatch('SET_LOADING_COMPONENT', { deliveryTypeInput: false }, { root: true }))
      })
    },
    FETCH_STREETS: (ctx, value) => {
      if (!value) {
        ctx.commit('SET_STREETS', [])
        return
      }
      const params = {
        cityId: ctx.rootState.checkout.formData.city.id,
        cityName: value
      }
      axios
        .get(ctx.rootGetters.urlLanguagePrefix + '/shop/checkout/get-streets/', { params })
        .then(response => ctx.commit('SET_STREETS', response.data.streets))
        .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
    },
    SEARCH_CITIES: (ctx, data) => {
      const { params, loading } = data
      if (!params) {
        return
      }
      return new Promise((resolve) => {
        axios
          .get(ctx.rootGetters.urlLanguagePrefix + '/shop/delivery-location/search-cities/', { params })
          .then(response => {
            ctx.commit('SET_CITIES', response.data)
            if (data && loading) {
              data.loading(false)
            }
            resolve(response.data)
          })
          .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
      })
    },
    SEARCH_STREETS: (ctx, data) => {
      const { params, loading } = data
      if (!params) {
        return
      }
      // params.cityUid = ctx.state.deliveryCity?.uid || ''
      // params.zipCode = ctx.state.deliveryCity?.zipCode || ''
      return new Promise((resolve) => {
        axios
          .get(ctx.rootGetters.urlLanguagePrefix + '/shop/delivery-location/search-streets/', { params })
          .then(response => {
            ctx.commit('SET_STREETS', response.data)
            if (data && loading) {
              data.loading(false)
            }
            resolve(response.data)
          })
          .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
      })
    },
    SEARCH_ZIP_CODES: (ctx, data) => {
      const { params, loading } = data
      if (!params) {
        return
      }
      // params.cityUid = ctx.state.deliveryCity?.uid || ''
      // params.zipCode = ctx.state.deliveryCity?.zipCode || ''
      return new Promise((resolve) => {
        axios
          .get(ctx.rootGetters.urlLanguagePrefix + '/shop/delivery-location/search-zip-codes/', { params })
          .then(response => {
            ctx.commit('SET_ZIP_CODES', response.data)
            if (data && loading) {
              data.loading(false)
            }
            resolve(response.data)
          })
          .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
      })
    },
    SEARCH_RELATED_DATA: (ctx, data) => {
      const { type, cityUid, id } = data
      if (!type || !cityUid) return
      const params = { type, cityUid, id }
      return new Promise((resolve) => {
        axios
          .get(ctx.rootGetters.urlLanguagePrefix + '/shop/delivery-location/get-related/', { params })
          .then(response => {
            if (type === 'zip') {
              ctx.commit('SET_STREETS', response.data)
            } else if (type === 'street') {
              ctx.commit('SET_ZIP_CODES', response.data)
            }
            resolve(response.data)
          })
          .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
      })
    },
    SET_LAST_DELIVERY_INFO_ACTION: ({ commit }, info) => {
      commit('SET_LAST_DELIVERY_INFO', info)

      const { id, house, street, city, zipCode, flat } = info
      commit('REDUCE_FORM_DATA', {
        deliveryInfo: { id, house, street, city, zipCode, flat }
      })
    },
    SET_IS_FORM_HIDDEN_ACTION ({ commit }, bool) {
      commit('SET_IS_FORM_HIDDEN', bool)
    },
    SET_DELIVERY_CITY ({ commit }, data) {
      commit('REDUCE_FORM_DATA', { deliveryCity: data })
      commit('SET_DELIVERY_CITY', data)
    },
    SET_DELIVERY_FORM_EMPTY_ACTION ({ commit }, bool) {
      commit('SET_DELIVERY_FORM_IS_EMPTY', bool)
    },
    VALIDATE_ANOTHER_RECIPIENT_FORM ({ commit, rootState, rootGetters }) {
      const { formData } = rootState.checkout

      if (!formData.recipientName) {
        commit('SET_INVALID_FIELDS', { recipientName: rootGetters.translations('blank_field_error') })
      }
      if (!formData.recipientLastName) {
        commit('SET_INVALID_FIELDS', { recipientLastName: rootGetters.translations('blank_field_error') })
      }
    },
    SUBMIT_DELIVERY ({ commit, rootGetters, getters, dispatch, rootState, state }) {
      if (!getters.isDeliveryFormValid) {
        commit('SET_DELIVERY_FORM_IS_EMPTY', true)
        dispatch('VALIDATE_ANOTHER_RECIPIENT_FORM')
      } else {
        commit('SET_IS_FORM_HIDDEN', true)
        commit('SET_IS_FORM_SUBMITTED', true)
        if (
          !rootState.checkout.formData.legalPersonInfo ||
          !Object.keys(rootState.checkout.formData.legalPersonInfo).length
        ) {
          dispatch('GET_LEGAL_HISTORY', { root: true })
        }
      }
      if (GoogleEnhancedEcommerce.isEnabled) {
        const value = rootGetters.cartInfoForEcommerce.reduce((acc, curr) => {
          return acc + curr.price * curr.quantity
        }, 0)
        if (rootGetters.cartInfoForEcommerce.length > 0) {
          GoogleEnhancedEcommerce.addShippingInfo({
            value,
            legal_personion: rootGetters.isLegalPerson ? 'yes' : 'no',
            shipping_tier: rootState.checkout.formData?.deliveryType?.title || '',
            another_person: state.isAnotherRecipient ? 'yes' : 'no',
            items: rootGetters.cartInfoForEcommerce.map(el => GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(el))
          })
        }
      } else {
        GoogleTagManagerService.pushToAnalytics({
          analyticsData: rootGetters.cartInfoForEcommerce,
          eventName: 'add_shipping_info',
          additionalFields: {
            shippingTier: state.deliveryInfo?.slug || ''
          }
        })
      }
    },
    SET_IS_MAP_TAB_ACTIVE_ACTION ({ commit }, isActive) {
      commit('SET_IS_MAP_TAB_ACTIVE', isActive)
    },
    SET_IS_ANOTHER_RECIPIENT_ACTION ({ commit }, bool) {
      commit('SET_IS_ANOTHER_RECIPIENT', bool)
    }
  }
}
